'use client';

import React from 'react';
import Icon from '@/components/ui/AppIcon';

interface FilterOption {
  label: string;
  value: string;
}

interface FilterBarProps {
  industries: FilterOption[];
  solutions: FilterOption[];
  businessSizes: FilterOption[];
  selectedIndustry: string;
  selectedSolution: string;
  selectedBusinessSize: string;
  searchQuery: string;
  onIndustryChange: (value: string) => void;
  onSolutionChange: (value: string) => void;
  onBusinessSizeChange: (value: string) => void;
  onSearchChange: (value: string) => void;
  onClearFilters: () => void;
}

const FilterBar = ({
  industries,
  solutions,
  businessSizes,
  selectedIndustry,
  selectedSolution,
  selectedBusinessSize,
  searchQuery,
  onIndustryChange,
  onSolutionChange,
  onBusinessSizeChange,
  onSearchChange,
  onClearFilters,
}: FilterBarProps) => {
  const hasActiveFilters = selectedIndustry !== 'all' || selectedSolution !== 'all' || selectedBusinessSize !== 'all' || searchQuery !== '';

  return (
    <div className="bg-card border border-border rounded-xl p-6 space-y-4">
      <div className="flex items-center justify-between">
        <h3 className="text-lg font-display font-bold text-foreground flex items-center space-x-2">
          <Icon name="FunnelIcon" size={20} className="text-primary" />
          <span>Filters</span>
        </h3>
        {hasActiveFilters && (
          <button
            onClick={onClearFilters}
            className="text-sm font-medium text-primary hover:text-primary/80 transition-colors duration-300 flex items-center space-x-1"
          >
            <Icon name="XMarkIcon" size={16} />
            <span>Wis filters</span>
          </button>
        )}
      </div>

      <div className="relative">
        <Icon
          name="MagnifyingGlassIcon"
          size={20}
          className="absolute left-3 top-1/2 -translate-y-1/2 text-muted-foreground"
        />
        <input
          type="text"
          placeholder="Zoek case studies..."
          value={searchQuery}
          onChange={(e) => onSearchChange(e.target.value)}
          className="w-full pl-10 pr-4 py-3 bg-background border border-border rounded-lg text-foreground placeholder:text-muted-foreground focus:outline-none focus:ring-2 focus:ring-primary/50 focus:border-primary transition-all duration-300"
        />
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <div>
          <label className="block text-sm font-semibold text-muted-foreground mb-2">
            Industrie
          </label>
          <select
            value={selectedIndustry}
            onChange={(e) => onIndustryChange(e.target.value)}
            className="w-full px-4 py-3 bg-background border border-border rounded-lg text-foreground focus:outline-none focus:ring-2 focus:ring-primary/50 focus:border-primary transition-all duration-300 cursor-pointer"
          >
            {industries.map((industry) => (
              <option key={industry.value} value={industry.value}>
                {industry.label}
              </option>
            ))}
          </select>
        </div>

        <div>
          <label className="block text-sm font-semibold text-muted-foreground mb-2">
            AI Oplossing
          </label>
          <select
            value={selectedSolution}
            onChange={(e) => onSolutionChange(e.target.value)}
            className="w-full px-4 py-3 bg-background border border-border rounded-lg text-foreground focus:outline-none focus:ring-2 focus:ring-primary/50 focus:border-primary transition-all duration-300 cursor-pointer"
          >
            {solutions.map((solution) => (
              <option key={solution.value} value={solution.value}>
                {solution.label}
              </option>
            ))}
          </select>
        </div>

        <div>
          <label className="block text-sm font-semibold text-muted-foreground mb-2">
            Bedrijfsgrootte
          </label>
          <select
            value={selectedBusinessSize}
            onChange={(e) => onBusinessSizeChange(e.target.value)}
            className="w-full px-4 py-3 bg-background border border-border rounded-lg text-foreground focus:outline-none focus:ring-2 focus:ring-primary/50 focus:border-primary transition-all duration-300 cursor-pointer"
          >
            {businessSizes.map((size) => (
              <option key={size.value} value={size.value}>
                {size.label}
              </option>
            ))}
          </select>
        </div>
      </div>
    </div>
  );
};

export default FilterBar;